import { Check } from 'lucide-react';
import { SPORT_CHOICES } from 'modules/arena/onboarding/content';
import { cn } from 'shared/utils/cn';
import { ArenaOnboardingState } from 'modules/arena/onboarding/useArenaOnboarding';

export function StepSports(state: ArenaOnboardingState) {
  return (
    <div>
      <p className="text-sm text-ink-secondary">Quais esportes a sua arena vai oferecer?</p>

      <div className="mt-4 flex flex-wrap gap-2">
        {SPORT_CHOICES.map((sport) => {
          const isSelected = state.selectedSportIds.includes(sport);

          return (
            <button
              key={sport}
              type="button"
              onClick={() => state.toggleSport(sport)}
              className={cn(
                'flex items-center gap-1.5 rounded-full border px-4 py-2 text-sm font-medium transition-colors',
                isSelected
                  ? 'border-primary bg-primary text-surface'
                  : 'border-border text-ink-secondary hover:border-primary'
              )}
            >
              {isSelected && <Check className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" />}
              {sport}
            </button>
          );
        })}
      </div>
    </div>
  );
}
